import { WrapperLineChart } from '../../../charts/WrapperCharts/WrapperLineChart/WrapperLineChart';
import { OlegHttps } from '../../../fetchUrls';
import "./CrossAnalyticsCharts.scss"


const CrossAnalyticsCharts = ({
    dataCharts,
    loadingCharts,
    body_obj
}) => {

    return (
        <div className='cross-analyticsc-charts'>
            <WrapperLineChart
                // url={`${OlegHttps}/api/v1/analytics/cross/graph/orders`}
                // body={body_obj()}
                loadingCharts={loadingCharts}
                dataCharts={dataCharts?.[0]}
                nameChart="Заказы"
            />

            <WrapperLineChart
                // url={`${OlegHttps}/api/v1/analytics/cross/graph/revenue`}
                // body={body_obj()}
                loadingCharts={loadingCharts}
                dataCharts={dataCharts?.[1]}
                nameChart="Выручка"
            />

            <WrapperLineChart
                // url={`${OlegHttps}/api/v1/analytics/cross/graph/AIV`}
                // body={body_obj()}
                loadingCharts={loadingCharts}
                dataCharts={dataCharts?.[2]}
                nameChart="AIV"
            />

            <WrapperLineChart
                // url={`${OlegHttps}/api/v1/analytics/cross/graph/expense`}
                // body={body_obj()}
                loadingCharts={loadingCharts}
                dataCharts={dataCharts?.[3]}
                nameChart="Затраты"
            />

            <WrapperLineChart
                // url={`${OlegHttps}/api/v1/analytics/cross/graph/ad_revenue`}
                // body={body_obj()}
                dataCharts={dataCharts?.[4]}
                loadingCharts={loadingCharts}
                nameChart="Выручка с товаров в рекламе"
            />

            <WrapperLineChart
                // url={`${OlegHttps}/api/v1/analytics/cross/graph/total_DRR`}
                // body={body_obj()}
                loadingCharts={loadingCharts}
                dataCharts={dataCharts?.[5]}
                nameChart="ДРР общий"
            />

            <WrapperLineChart
                // url={`${OlegHttps}/api/v1/analytics/cross/graph/ad_DRR`}
                // body={body_obj()}
                loadingCharts={loadingCharts}
                dataCharts={dataCharts?.[6]}
                nameChart="ДРР реклама"
            />

            <WrapperLineChart
                // url={`${OlegHttps}/api/v1/analytics/cross/graph/ad_revenue_share`}
                // body={body_obj()}
                loadingCharts={loadingCharts}
                dataCharts={dataCharts?.[7]}
                nameChart="Процент выручки с товаров в рекламе"
            />

            <WrapperLineChart
                // url={`${OlegHttps}/api/v1/analytics/cross/graph/views`}
                // body={body_obj()}
                loadingCharts={loadingCharts}
                dataCharts={dataCharts?.[8]}
                nameChart="Показы"
            />

            <WrapperLineChart
                // url={`${OlegHttps}/api/v1/analytics/cross/graph/to_cart`}
                // body={body_obj()}
                loadingCharts={loadingCharts}
                dataCharts={dataCharts?.[9]}
                nameChart="Корзины"
            />

            <WrapperLineChart
                // url={`${OlegHttps}/api/v1/analytics/cross/graph/CR_views_to_cart`}
                // body={body_obj()}
                loadingCharts={loadingCharts}
                dataCharts={dataCharts?.[10]}
                nameChart="CR показы в корзины"
            />

            <WrapperLineChart
                // url={`${OlegHttps}/api/v1/analytics/cross/graph/CR_to_cart_orders`}
                // body={body_obj()}
                loadingCharts={loadingCharts}
                dataCharts={dataCharts?.[11]}
                nameChart="CR корзины в заказы"
            />

            <WrapperLineChart
                // url={`${OlegHttps}/api/v1/analytics/cross/graph/CR_views_orders`}
                // body={body_obj()}
                loadingCharts={loadingCharts}
                dataCharts={dataCharts?.[12]}
                nameChart="CR показы в заказы"
            />
        </div>
    )
}

export { CrossAnalyticsCharts }